"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cropRect = cropRect;
exports.adjustCrop = adjustCrop;
const clamp = (value, low, high) => Math.max(low, Math.min(high, value));
function cropRect(width, height, zoom, x, y) {
    const side = Math.min(width, height) / clamp(zoom, 1, 4);
    return { x: (width - side) * clamp(x, 0, 1), y: (height - side) * clamp(y, 0, 1), side };
}
/** Resize against the opposite corner/edge, keeping a square entirely inside the photo. */
function adjustCrop(rect, handle, dx, dy, width, height) {
    if (handle === 'move')
        return { ...rect, x: clamp(rect.x + dx, 0, width - rect.side), y: clamp(rect.y + dy, 0, height - rect.side) };
    const horizontal = handle.includes('e') ? 1 : handle.includes('w') ? -1 : 0;
    const vertical = handle.includes('s') ? 1 : handle.includes('n') ? -1 : 0;
    const anchorX = rect.x + (horizontal < 0 ? rect.side : horizontal > 0 ? 0 : rect.side / 2);
    const anchorY = rect.y + (vertical < 0 ? rect.side : vertical > 0 ? 0 : rect.side / 2);
    const maxX = horizontal > 0 ? width - anchorX : horizontal < 0 ? anchorX : 2 * Math.min(anchorX, width - anchorX);
    const maxY = vertical > 0 ? height - anchorY : vertical < 0 ? anchorY : 2 * Math.min(anchorY, height - anchorY);
    const delta = (horizontal * dx + vertical * dy) / (horizontal && vertical ? 2 : 1);
    const side = clamp(rect.side + delta, Math.min(width, height) / 20, Math.min(maxX, maxY));
    return { x: anchorX - (horizontal < 0 ? side : horizontal > 0 ? 0 : side / 2), y: anchorY - (vertical < 0 ? side : vertical > 0 ? 0 : side / 2), side };
}
//# sourceMappingURL=crop.js.map